import { createSlice, PayloadAction } from "@reduxjs/toolkit"

import { RootState } from "stores/store"

import { Place, SaveSearchIntialState } from "./types"

const initialState: SaveSearchIntialState = {
  loading: true,
  error: null,
  searchAddressResult: null,
  isLocationName: "",
}

export const saveSearchSlice = createSlice({
  name: "saveSearch",
  initialState,
  reducers: {
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload
    },
    setSearchAddressResult: (state, action: PayloadAction<Place | null>) => {
      state.searchAddressResult = action.payload
    },
    setLocationName: (state, action: PayloadAction<string>) => {
      state.isLocationName = action.payload
    },
  },
})

export const { setLoading, setSearchAddressResult, setLocationName } =
  saveSearchSlice.actions

export const selectSearchAddressResult = (state: RootState) =>
  state.saveSearchReducer.searchAddressResult

export const selectLocationName = (state: RootState) =>
  state.saveSearchReducer.isLocationName

export default saveSearchSlice.reducer
